module.exports = __webpack_public_path__ + "media/images/icons/icon_hamburger_black-15698b9f535c6c1b1f8818c6aca52183.svg";